import { Card, Button } from 'react-bootstrap'
import useCallApi from '../../../../hooks/useCallApi'
import Loading from '../../../../templates/UI/Loading/Loading'
import { useAuth, useProtectedPage } from '../../../../context/AuthContext'
import { useEffect, useState } from 'react'
import TrackingModal from './TrackingModal'
import ReportTable from '../../../../templates/ReportTable/ReportTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGoogle } from "@fortawesome/free-brands-svg-icons"
import TrackingPlatformsHistoryModal from './TrackingPlatformsHistoryModal/TrackingPlatformsHistoryModal'
import { Table } from 'react-bootstrap'

const AdvertiserTrackingPlatforms = ({ showSystemMessage, advertiserId, platformId }) => {
    document.title = 'Advertiser Tracking Platforms'

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'advertiser_platforms')

    const [isOpen, setIsOpen] = useState(false)
    const [showPlatformHistory, setShowPlatformHistory] = useState(false)
    const [selectedPlatform, setSelectedPlatformId] = useState({ id: 0, name: '' })
    const [id, setId] = useState(0)
    const [isCreate, setIsCreate] = useState(true)
    const { data, setData, dataLoaded, refetch } = useCallApi(`advertisers/platformsList`, 'GET', {}, [], showSystemMessage)

    useEffect(() => {
        if (dataLoaded && platformId > 0) {
            setIsCreate(false)
            let index = data.platformsList.findIndex((item) => parseInt(item.platform_id) === parseInt(platformId))

            if (index >= 0) {
                setId(index)
                setIsOpen(true)
            }
        }
    }, [platformId, dataLoaded])

    const columns = [
        {
            Header: 'Platform Name',
            accessor: 'platform_name',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <Button variant="link" className='text-left' onClick={() => {
                    setShowPlatformHistory(true)
                    setSelectedPlatformId({ id: row.platform_id, name: row.platform_name })
                }}>{row.platform_name}</Button>
            }
        },
        {
            Header: 'Supports Multiple Postbacks',
            accessor: 'supports_multiple_postback',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <>{row.supports_multiple_postback === 'Y' ? 'Yes' : 'No'}</>
            },
        },
        {
            Header: 'API Tracking',
            accessor: 'api_tracking',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <>{row.api_tracking === 'Y' ? 'Yes' : 'No'}</>
            },
        },
        {
            Header: 'Allows Safesearch',
            accessor: 'allows_safesearch',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <>{row.allows_safesearch === 'Y' ? 'Yes' : 'No'}</>
            },
        },
        {
            Header: <><span className="text-danger"><FontAwesomeIcon icon={faGoogle} /></span> Google Certified</>,
            accessor: 'safesearch_certified',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <>{row.safesearch_certified === 'Y' ? 'Yes' : 'No'}</>
            },
        },
        {
            Header:  <><span className="text-danger"><FontAwesomeIcon icon={faGoogle} /></span> Appended to LP Url</>,
            accessor: 'n/a',
            Cell: (tableData) => {
                const row = tableData.row.original
                return <>
                    {row.safesearch_certified === 'Y' ?
                        (row.safesearch_enable_param && row.safesearch_enable_value) ?
                            `&${row.safesearch_enable_param}=${row.safesearch_enable_value}&${row.safesearch_url_param}=[landing_page_setting_url]`
                            :
                            `&${row.safesearch_url_param}=[landing_page_setting_url]`
                        :
                        ''
                    }
                </>
            },
        },
        {
            Header: '',
            accessor: 'platform_id', 
            disableSortBy: true,
            Cell: (tableData) => {
                const rowIndex = tableData.row.index
                return (
                    <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                            setId(rowIndex)
                            setIsCreate(false)
                            setIsOpen(true)
                        }}
                    >
                        Edit
                    </Button>
                )
            },
        },
    ]

    return (
        <div>
            {isOpen && <TrackingModal
                id={id}
                setIsCreate={setIsCreate}
                showSystemMessage={showSystemMessage}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                isCreate={isCreate}
                data={isCreate ? { success: true } : data}
                setData={(value) => {
                    const platformsList = [...(data.platformsList || [])]
                    platformsList[id] = { ...platformsList[id], ...value }
                    setData({ ...data, platformsList })
                }}
                dataLoaded={dataLoaded}
                refetch={refetch}
            />}
            {showPlatformHistory && <TrackingPlatformsHistoryModal isOpen={showPlatformHistory} onClose={() => setShowPlatformHistory(false)} platform={selectedPlatform} />}
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Advertiser Tracking Platforms</h1>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <Card className="mb-3 p-0">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span>
                                <span className="mr-1 d-flex">
                                    <span style={{ width: '-webkit-fill-available' }}>Manage Platforms</span>
                                </span>
                            </span>
                            <Button
                                variant="warning"
                                size="sm"
                                onClick={() => {
                                    setIsCreate(true)
                                    setIsOpen(true)
                                }}
                            >
                                Add New Platform
                            </Button>
                        </Card.Header>
                        {dataLoaded && data.success ? (
                            data.platformsList.length === 0 ? (
                                <div className="p-3 text-center">No Advertiser Platforms Available</div>
                            ) : (
                                <ReportTable data={data.platformsList} columns={columns} />
                            )
                        ) : (
                            <div className="p-3">
                                <Loading />
                            </div>
                        )}
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default AdvertiserTrackingPlatforms
